export default __webpack_public_path__ + "static/media/fileIcon.9d11848b.svg";